import { get, post, put, deleteRequest, patch } from "./api";

export interface TeamMember {
  id: number;
  name: string;
  position: string;
  photo: string;
  displayOrder: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface TeamMemberInput {
  name: string;
  position: string;
  photo?: File;
  displayOrder?: number;
  isActive?: boolean;
}

// Get all team members
export const getTeamMembers = async (
  activeOnly: boolean = false
): Promise<TeamMember[]> => {
  const query = activeOnly ? "?active=true" : "";
  const response = await get(`/team-members${query}`);
  return response.data.data;
};

// Get single team member
export const getTeamMember = async (id: number): Promise<TeamMember> => {
  const response = await get(`/team-members/${id}`);
  return response.data.data;
};

// Create new team member
export const createTeamMember = async (
  data: TeamMemberInput
): Promise<TeamMember> => {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("position", data.position);
  if (data.photo) {
    formData.append("photo", data.photo);
  }
  if (data.displayOrder !== undefined) {
    formData.append("displayOrder", data.displayOrder.toString());
  }
  if (data.isActive !== undefined) {
    formData.append("isActive", data.isActive.toString());
  }

  const response = await post("/team-members", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data.data;
};

// Update team member
export const updateTeamMember = async (
  id: number,
  data: Partial<TeamMemberInput>
): Promise<TeamMember> => {
  const formData = new FormData();
  if (data.name) formData.append("name", data.name);
  if (data.position) formData.append("position", data.position);
  if (data.photo) formData.append("photo", data.photo);
  if (data.displayOrder !== undefined) {
    formData.append("displayOrder", data.displayOrder.toString());
  }
  if (data.isActive !== undefined) {
    formData.append("isActive", data.isActive.toString());
  }

  const response = await put(`/team-members/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data.data;
};

// Delete team member
export const deleteTeamMember = async (id: number): Promise<void> => {
  await deleteRequest(`/team-members/${id}`);
};

// Reorder team members
export const reorderTeamMembers = async (
  orders: Array<{ id: number; displayOrder: number }>
): Promise<void> => {
  await patch("/team-members/reorder", { orders });
};

export default {
  getTeamMembers,
  getTeamMember,
  createTeamMember,
  updateTeamMember,
  deleteTeamMember,
  reorderTeamMembers,
};
